import ConfigForm, { ConfigInput } from "components/Layout/ConfigForm";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";

export enum RoleTypeEnum {
  PATROL = "Patrol",
  ROAM = "Roam",
  STATION = "Station",
}

interface BasicRoleConfigProps {
  handleRoleNameChange: (name: string) => void;
  handleTrackingTypeChange: (trackingType: "Indoor" | "Outdoor") => void;
  handleRoleTypeChange: (type: RoleTypeEnum) => void;
}
interface BasicRoleConfigState {
  name: string;
  type: RoleTypeEnum;
  trackingType: string;
}

const DEFAULT_STATE: BasicRoleConfigState = {
  name: "",
  type: RoleTypeEnum.PATROL,
  trackingType: "",
};
export default function BasicRoleConfig(props: BasicRoleConfigProps) {
  const [state, setState] = React.useState<BasicRoleConfigState>(DEFAULT_STATE);
  const roleTypes = [
    { value: RoleTypeEnum.PATROL, label: RoleTypeEnum.PATROL },
    { value: RoleTypeEnum.ROAM, label: RoleTypeEnum.ROAM },
    { value: RoleTypeEnum.STATION, label: RoleTypeEnum.STATION },
  ];

  const trackingTypes = [
    { value: "Indoor", label: "Indoor" },
    { value: "Outdoor", label: "Outdoor" },
  ];

  const handleRoleNameChange = (event: any) => {
    setState({ ...state, name: event.target.value });
    props.handleRoleNameChange(event.target.value);
  };

  const handleTrackingTypeChange = (event: any) => {
    setState({ ...state, trackingType: event.target.value });
    props.handleTrackingTypeChange(event.target.value as "Indoor" | "Outdoor");
  };

  const handleRoleTypeChange = (event: any) => {
    setState({ ...state, type: event.target.value });
    props.handleRoleTypeChange(event.target.value as RoleTypeEnum);
  };
  const inputs: ConfigInput[] = [
    {
      title: "Role Name",
      required: true,
      type: "text",
      onChange: handleRoleNameChange,
      placeholder: "Required",
      xs: 12,
      sm: 6,
      id: "roleName",
      value: state.name,
    },
    {
      title: "Select Role Type",
      type: "select",
      onChange: handleRoleTypeChange,
      xs: 12,
      sm: 6,
      id: "roleType",
      placeholder: "Required",
      options: roleTypes,
      value: state.type,
    },
    {
      title: "Select Tracking Type",
      type: "radio",
      onChange: handleTrackingTypeChange,
      xs: 12,
      sm: 12,
      id: "trackingType",
      placeholder: "select tracking type",
      options: trackingTypes,
      value: state.trackingType,
    },
  ];
  return <ConfigForm inputs={inputs}></ConfigForm>;
}
